import React, { createContext, FC, PropsWithChildren, useContext } from "react"

type CreateUpdateContextType = {
  isCreating: boolean
  isArchived: boolean
  isLegacy?: boolean
}

export const CreateUpdateContext = createContext<CreateUpdateContextType>({
  isCreating: true,
  isArchived: false,
})
export const CreateUpdateProvider: FC<
  PropsWithChildren<{
    isArchived: boolean
    isCreating: boolean
    isLegacy?: boolean
  }>
> = ({ isLegacy, isCreating, isArchived, children }) => {
  return (
    <CreateUpdateContext.Provider
      value={{
        isCreating,
        isArchived,
        isLegacy,
      }}
    >
      {children}
    </CreateUpdateContext.Provider>
  )
}

export const useCreateUpdate = () => useContext(CreateUpdateContext)
